import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { FETCH_CONTACTS } from '../model/constants'
import { IPartnerContact } from '../model/types'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

interface IFetchContactsParams {
  force?: boolean
}

export const fetchContacts = createAsyncThunk<IPartnerContact[], IFetchContactsParams | void>(
  FETCH_CONTACTS,
  async ({ force = false } = { force: false }, { getState }) => {
    const { partnerId, programType } = selectContactsFilters(getState())
    const crud = getPartnerContactsCrud({ partnerId, programType })

    const result = await crud.fetch({ force })

    return structuredClone(result.items)
  }
)
